import { ManufacturingLifecycleStatus } from '../../constants/manufacturing-lifecycle-status.js';
import { MANUFACTURING_TERMINAL_STATUS_IDS } from './terminal-status-ids.js';
const TERMINAL = new Set(MANUFACTURING_TERMINAL_STATUS_IDS);
/** Every status that means a ticket has been worked, not merely released. */
const STARTED = new Set([
    ManufacturingLifecycleStatus.PICK,
    ManufacturingLifecycleStatus.IN_PROGRESS,
    ManufacturingLifecycleStatus.IN_TESTING,
    ManufacturingLifecycleStatus.COMPLETED,
]);
/** The status a job or a job line takes from its children. */
export function deriveParentStatus(children) {
    if (children.length === 0) {
        return ManufacturingLifecycleStatus.DRAFT;
    }
    if (children.every((child) => child.statusId === ManufacturingLifecycleStatus.CANCELLED)) {
        return ManufacturingLifecycleStatus.CANCELLED;
    }
    if (children.every((child) => TERMINAL.has(child.statusId))) {
        return ManufacturingLifecycleStatus.COMPLETED;
    }
    const live = children.filter((child) => child.statusId !== ManufacturingLifecycleStatus.CANCELLED);
    // `some`, not `every`: one ticket being picked while two sit untouched is a job under way, and
    // Issued would tell the floor nothing had happened.
    if (live.some((child) => STARTED.has(child.statusId))) {
        return ManufacturingLifecycleStatus.IN_PROGRESS;
    }
    if (live.every((child) => child.statusId === ManufacturingLifecycleStatus.DRAFT)) {
        return ManufacturingLifecycleStatus.DRAFT;
    }
    return ManufacturingLifecycleStatus.ISSUED;
}
//# sourceMappingURL=derive-parent-status.js.map